import { isValidUrl as isValidUrl$1, isNotDefined } from '@togglecorp/fujs';

// FIXME: check if this can be done without backward referencing
// NOTE: used for validation
const localhostRegex = /(?<=\/\/)localhost(?=[:/]|$)/;
function isLocalUrl(url) {
  return localhostRegex.test(url);
}

// FIXME: move this to fujs
// NOTE: used for validation
function isValidUrl(url) {
  if (!url) {
    return false;
  }
  const sanitizedUrl = url.replace(localhostRegex, 'localhost.com');
  return isValidUrl$1(sanitizedUrl);
}

// NOTE: we are not using isDefined from fujs because it treats NaN as not defined
// NOTE: used for validation
function isDefined(value) {
  return value !== undefined && value !== null;
}

// NOTE: used for validation
function isDefinedString(value) {
  return isDefined(value) && value.trim() !== '';
}
function hasNoKeys(obj) {
  return isNotDefined(obj) || Object.keys(obj).length + Object.getOwnPropertySymbols(obj).length === 0;
}
function hasNoValues(array) {
  return isNotDefined(array) || array.length <= 0 || array.every(e => isNotDefined(e));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any

function isCallable(value) {
  return typeof value === 'function';
}

export { hasNoKeys, hasNoValues, isCallable, isDefined, isDefinedString, isLocalUrl, isValidUrl };
//# sourceMappingURL=utils.js.map
